(function () {
    'use strict';

    var controllerId = 'apiNavigatorController';
    var module = angular.module('app.directives');

    module.directive('apiNavigator', ['config', function (config) {
        var directive = {
            restrict: 'AE',
            replace: true,
            controller: controllerId,
            controllerAs: 'navApiMenuVm',
            templateUrl: config.clientAppSrcPath + 'app/directives/apiNavigator/apiNavigator.html',
            link: link
        };

        return directive;

        function link() {

        }
    }]);

    module.controller(controllerId, ['common', 'swaggerService', apiNavigatorController]);

    function apiNavigatorController(common, swaggerService) {
        var vm = this;

        //vm.isSelected = isSelected;
        vm.menuInfos = [];
        vm.getOperationsList = getOperationsList;

        activate();

        function activate() {
            common.handleBusyState([getNavRoutes()], controllerId);
        }

        function getNavRoutes() {
            vm.menuInfos.length = 0;
            var menuInfos = [];
            return swaggerService.getApiList().then(function (apiList) {
                for (var apiIndex in apiList) {
                    var api = apiList[apiIndex];
                    var menuInfo = { stateName: 'api', apiId: api.id, resourceKey: api.apiNameEn, subMenuInfos: null, iconClass: '', nav: '' };
                    menuInfos.push(menuInfo);
                }
                vm.menuInfos = menuInfos;
            });
        }

        function getOperationsList(menuInfo) {
            if (menuInfo && !menuInfo.subMenuInfos) {
                swaggerService.getOperationsByApiId(menuInfo.apiId).then(function (swaggerOperations) {
                    if (!menuInfo.subMenuInfos && swaggerOperations) {
                        menuInfo.subMenuInfos = [];
                        for (var swaggerOperation in swaggerOperations) {
                            var operationid = swaggerOperations[swaggerOperation].operation.operationId;
                            menuInfo.subMenuInfos.push({ stateName: 'api.operations.detail', operationId: operationid, resourceKey: operationid });
                        }
                    }
                });
            }
        }
    };
})();